export default "__VITE_ASSET__D54D_iF8__"